// extracted by mini-css-extract-plugin
module.exports = {"title":"intro_title__zm_Nm","imageContainer":"intro_imageContainer__S73pY","image":"intro_image___sPmg"};